<template>
  <v-card>
    <v-card-title class="d-flex align-center">
      <h1 class="text-2xl font-weight-semibold">
        {{ title }}
      </h1>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :footer-props="footer"
      :items="data"
      :items-per-page="10"
      :no-data-text="$t('noDataText')"
      item-key="id"
      class="table-rounded"
      multi-sort
    >
      <template #[`item.action`]="{item}">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              color="secondary"
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="item"
            >
              <v-icon size="24">
                {{ icons.mdiPencilOutline }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("tooltip.edit") }}</span>
        </v-tooltip>
        <confirmation-modal>
          <template v-slot:default="{ dialogOn }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="error"
                  v-bind="attrs"
                  v-on="{ ...on, ...dialogOn }"
                >
                  <v-icon size="24">
                    {{ icons.mdiDeleteOutline }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("tooltip.delete") }}</span>
            </v-tooltip>
          </template>
        </confirmation-modal>
      </template>
      <template v-slot:[`footer.page-text`]="items">
        {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
      </template>
    </v-data-table>
  </v-card>
</template>

<style scoped>
.pseudo-breadcrumb {
  background-color: #fafafa;
  padding: 1rem;
}

.paragraph {
  padding-left: 2.5rem;
}
</style>

<script>
import { mdiPencilOutline, mdiDeleteOutline } from '@mdi/js';
import ConfirmationModal from '@/components/ConfirmationModal.vue';

export default {
  components: {
    ConfirmationModal,

  },
  data() {
    return {
      title: this.$t('pages.schedules_historic'),
      data: [],
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Unidade', value: 'name_department' },
        { text: 'Medico', value: 'name_client' },
        { text: 'Estado', value: 'status' },
        { text: 'Preço por dia', value: 'price_per_hour' },
        { text: 'Data de inicio', value: 'start_date' },
        { text: 'Data de fechamento', value: 'end_date' },
        { text: 'Pago', value: 'paid' },
        {
          text: 'Ações',
          align: 'center',
          value: 'action',
          sortable: false,
          width: '20%',
        },
      ],
      icons: {
        mdiPencilOutline,
        mdiDeleteOutline,
      },
      footer: {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageAll: 'Todos',
      },
    };
  },
  async mounted() {
    try {
      let response = await this.$api.schedule.scheduleHistoric(
        this.$route.params.departmentId,
      );
      response = response.success.map((item) => ({
        id: item.id,
        name_client: item.customer.name,
        name_department: item.department.name,
        price_per_hour: item.price_per_hour,
        status: item.status,
        paid: item.paid === 1 ? 'Pago' : 'Pendente',
        start_date: item.start_date,
        end_date: item.end_date,
      }));

      this.data = response;
    } catch (error) {
      this.$store.dispatch('NOTIFICATION_ERROR', error.message);
    }
  },
  methods: {
    noop() {
      return null;
    },
  },
};
</script>
